import React from "react";
import Paginator from "./paginator.jsx";
import moment from "moment";
import context from "./../../lib/context.js";
import ajax from "./../../lib/context.js";

export default class HistoryTCList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let items = [];
        let hiddenColumns = this.props.hideColumns? this.props.hideColumns.split(','): [];

        let vm = this.props.vm; // Expected to be an array of listItem
        let totalPage = vm.total / vm.pageSize + 
            (vm.total % vm.pageSize > 0 ? 1 : 0); 
        if (vm == null || vm.timecards == null || vm.timecards == 0) {
            return(
                <div className="ap-fullsize ap-grid-result text-center">
                    No Timecard Found!
                </div>
                );
        } else {
            for(let i=0; i<vm.timecards.length; i++) {
                let tc = vm.timecards[i].timecardSummary? vm.timecards[i].timecardSummary: vm.timecards[i]; // check first if result came from Legacy API
                let url = this.props.onGetItemUrl? this.props.onGetItemUrl(vm.timecards[i]): '#';
                items.push(
                    <div className="row ap-timecard-list-item" key={i}>
                        <section className="hidden-sm hidden-xs">
                            <div className={hiddenColumns.includes("people")? "ap-hidden": "col-md-2 col-lg-2"}>
                                <a href={url} className="ap-person-name">{tc.peopleName}</a>
                            </div>
                            <div className={hiddenColumns.includes("client")? "ap-hidden": "col-md-2 col-lg-2"}>
                                <a href={url} className="ap-person-name">{tc.clientName}</a>
                            </div>
                            {
                                hiddenColumns.length == 0 ?
                                    <div className="col-md-3 col-lg-3 ap-color-darkgray">
                                        <div className="col-md-3 col-lg-3 ap-color-darkgray ap-no-padding-left">
                                            {tc.placementId}
                                        </div>
                                        <div className="col-md-3 col-lg-3 ap-color-darkgray ap-no-padding-left">
                                            {moment(tc.weekEnding).format("MM/DD/YYYY")}
                                        </div>
                                        <div className="col-md-6 col-lg-6 ap-color-darkgray">
                                            {tc.reportToName}
                                        </div>
                                    </div> : null
                            }
                            {
                                hiddenColumns.length > 0 ?
                                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                                        {tc.placementId}
                                    </div> : null
                            }
                            {
                                hiddenColumns.length > 0 ?
                                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                                        {moment(tc.weekEnding).format("MM/DD/YYYY")}
                                    </div> : null
                            }
                            {
                                hiddenColumns.length > 0 ?
                                    <div className="col-md-2 col-lg-2 ap-color-darkgray">
                                        {tc.reportToName}
                                    </div> : null
                            }
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.regularHour} : {tc.regularMin}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.otHour} : {tc.otMin}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.dtHour} : {tc.dtMin}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.totalExpense.toFixed(2)}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.statusDescription}
                            </div>
                        </section>
                        <section className="hidden-md hidden-lg">
                            <div className="col-xs-6 col-sm-6">                        
                                <b>{moment(tc.weekEnding).format("MM/DD/YYYY")}</b>
                            </div>
                            <div className={hiddenColumns.includes("people")? "ap-hidden": "col-xs-12 col-sm-12"}>
                                <a href={url} className="ap-person-name">{tc.peopleName}</a>
                            </div> 
                            <div className={hiddenColumns.includes("client")? "ap-hidden": "col-xs-12 col-sm-12"}>
                                <a href={url} className="ap-person-name">{tc.clientName}</a>
                            </div>
                            <div className="col-xs-12 col-sm-12">
                                <span className="ap-color-gray">Assign ID </span>
                                <b>{tc.placementId}</b>
                            </div>  
                            <div className="col-xs-12 col-sm-12 ap-separator-col">                        
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Regular Time </span><br/>
                                <b>{tc.regularHour} : {tc.regularMin}</b>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Over Time </span><br/>
                                <b>{tc.otHour} : {tc.otMin}</b>
                            </div>
                            <div className="col-xs-12 col-sm-12 ap-separator-col">              
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Double Time </span><br/>
                                <b>{tc.dtHour} : {tc.dtMin}</b>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Misc </span><br/>
                                <b>{tc.totalExpense.toFixed(2)}</b>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Status </span><br/>
                                <b>{tc.statusDescription}</b>
                            </div>
                            <div className="col-xs-12 col-sm-12 ap-separator-col">          
                            </div>
                        </section>
                    </div>
                    );              
            }
        }

        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="container-fluid ap-timecard-list-header">
                            <div className="row">
                                <div className={hiddenColumns.includes("people")? "ap-hidden": "hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title"} >
                                     Associate
                                </div>
                                <div className={hiddenColumns.includes("client")? "ap-hidden": "hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title"} >
                                     Client
                                </div>
                                {
                                    hiddenColumns.length == 0 ?
                                        <div className="hidden-xs hidden-sm col-md-3 col-lg-3 ap-col-title ap-no-padding-left">
                                            <div className="hidden-xs hidden-sm col-md-3 col-lg-3 ap-col-title">
                                                Assign ID
                                            </div>
                                            <div className="hidden-xs hidden-sm col-md-3 col-lg-3 ap-col-title">
                                                Week Ending
                                            </div>
                                            <div className="hidden-xs hidden-sm col-md-6 col-lg-6 ap-col-title">
                                                Report To
                                            </div>
                                        </div> : null
                                }
                                {
                                    hiddenColumns.length > 0 ?
                                        <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                            Assign ID
                                        </div> : null
                                }
                                {
                                    hiddenColumns.length > 0 ?
                                        <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                            Week Ending
                                        </div> : null
                                }
                                {
                                    hiddenColumns.length > 0 ?
                                        <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title">
                                            Report To
                                        </div> : null
                                }
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    Regular hour/min
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    OverTime hour/min
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    DoubleTime hour/min
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    Misc Hours
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    Status
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="row">                        
                    <div className="col-lg-12">                            
                        <div className="container-fluid ap-timecard-list">
                            {items}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Paginator total={totalPage} range="3" selectedIndex={vm.page} 
                            onNavigate={this.props.onNavigate}  />
                    </div>
                </div>
            </div>
        );
    }
}